<template>
  <div class="chatlyn-container my-8 grid gap-8 md:grid-cols-3">
    <div class="col-span-1">
      <div class="text text-lg font-medium txt-primary">
        {{ $t('CHATLYN_SUBSCRIPTION.INFORMATION.TITLE') }}
      </div>
      <p class="text txt-secondary">
        {{ $t('CHATLYN_SUBSCRIPTION.INFORMATION.NOTE') }}
      </p>
    </div>
    <div class="col-span-2 flex flex-col gap-4">
      <InformationCard
        v-for="(clientCost, index) in clientCosts"
        :key="index"
        :statistics="clientCost"
        :title="clientCost.title"
      />
    </div>
  </div>
</template>

<script>
import InformationCard from 'dashboard/routes/dashboard/settings/subscription/information/InformationCard.vue';

export default {
  name: 'InformationContainer',
  components: {
    InformationCard,
  },
  props: {
    clientCosts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss"></style>
